<template>
  <div class="auto-payment-container">
    <div v-if="loading" class="loading-message">
      <h2>Procesando pago automático...</h2>
      <div class="spinner"></div>
    </div>
    
    <div v-else-if="error" class="error-message">
      <h2>Error</h2>
      <p class="error-text">{{ error }}</p>
      
      <!-- Mostrar detalles del error de la API -->
      <div v-if="errorDetails" class="error-details">
        <div v-if="errorDetails.message" class="error-detail">
          <strong>Mensaje:</strong> {{ errorDetails.message }}
        </div>
        
        <div v-if="errorDetails.lastPayment" class="last-payment-info">
          <h3>Último Pago Realizado:{{errorDetails.lastPayment.createdAt  }}</h3>
          <div class="payment-details">
            <p><strong>ID:</strong> {{ errorDetails.lastPayment._id }}</p>
            <p><strong>Usuario:</strong> {{ errorDetails.lastPayment.user }}</p>
            <p><strong>Monto:</strong> {{ errorDetails.lastPayment.amount }} {{ errorDetails.lastPayment.currency }}</p>
            <p v-if="errorDetails.lastPayment.date"><strong>Fecha:</strong> {{ formatDate(errorDetails.lastPayment.date) }}</p>
            <p v-if="errorDetails.lastPayment.status"><strong>Estado:</strong> {{ errorDetails.lastPayment.status }}</p>
          </div>
        </div>
      </div>
    </div>
    
    <div v-else-if="success" class="success-message">
      <h2>Pago Procesado Exitosamente</h2>
      <p>{{ successMessage }}</p>
    </div>
  </div>
</template>

<script>
import { wencesApi } from "@/api/wencesApi";
import { isValidToken } from "@/config/secrets";

export default {
  name: "AutoPayment",
  data() {
    return {
      loading: true,
      error: null,
      errorDetails: null,
      success: false,
      successMessage: ""
    };
  },
  async created() {
    await this.processAutoPayment();
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      return date.toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    async processAutoPayment() {
      try {
        // Obtener el token de la URL
        const token = this.$route.params.token;
        
        if (!token) {
          this.error = "Token no proporcionado";
          this.loading = false;
          return;
        }

        // Verificar que el token sea el correcto usando la configuración
        if (!isValidToken('AUTO_PAYMENT_GYM', token)) {
          this.error = "Token inválido";
          this.loading = false;
          return;
        }

        // Hacer la llamada a la API
        const response = await wencesApi.post("/api/payments/auto-payment-gym", {
          token: token,
          timestamp: new Date().toISOString()
        });

        if (response.data.success) {
          this.success = true;
          this.successMessage = response.data.message || "Pago automático procesado correctamente";
        } else {
          this.error = response.data.message || "Error al procesar el pago automático";
          // Guardar detalles del error si están disponibles
          if (response.data.error || response.data.lastPayment) {
            this.errorDetails = {
              message: response.data.message,
              lastPayment: response.data.lastPayment
            };
          }
        }

      } catch (error) {
        console.error("Error en auto-payment:", error);
        
        // Intentar extraer información del error de la API
        if (error.response && error.response.data) {
          this.error = error.response.data.message || error.response.data.error || "Error interno del servidor";
          this.errorDetails = {
            message: error.response.data.message,
            lastPayment: error.response.data.lastPayment
          };
        } else {
          this.error = "Error interno del servidor. Por favor, inténtalo de nuevo.";
        }
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.auto-payment-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  font-family: 'Arial', sans-serif;
}

.loading-message,
.error-message,
.success-message {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  text-align: center;
  max-width: 500px;
  width: 90%;
}

.loading-message h2,
.error-message h2,
.success-message h2 {
  margin-bottom: 1rem;
  color: #333;
}

.error-message h2 {
  color: #e74c3c;
}

.success-message h2 {
  color: #27ae60;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 1rem auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-text {
  color: #e74c3c;
  font-weight: bold;
  margin-bottom: 1rem;
}

.error-details {
  text-align: left;
  margin-top: 1rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 5px;
  border-left: 4px solid #e74c3c;
}

.error-detail {
  margin-bottom: 0.5rem;
  color: #666;
}

.last-payment-info {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #ddd;
}

.last-payment-info h3 {
  color: #333;
  margin-bottom: 0.5rem;
  font-size: 1rem;
}

.payment-details {
  background: white;
  padding: 0.5rem;
  border-radius: 3px;
  border: 1px solid #ddd;
}

.payment-details p {
  margin: 0.25rem 0;
  color: #666;
  font-size: 0.9rem;
}

.error-message p,
.success-message p {
  color: #666;
  line-height: 1.5;
}
</style> 